import { createAction, handleActions } from "redux-actions"
import { apiGet } from "../utils/apiConnector"
import {
  shardedAnalyticsApi,
  productShardedAnalyticsApi,
} from "../config/apiUrls"
import { endOfDay, startOfDay } from "date-fns"
import { forEachObjIndexed, mergeDeepRight } from "ramda"

export const shardedAnalyticsTypes = {
  profit: "profit",
  sale: "sale",
  purchase: "purchase",
}

// Default state
const defaultState = {
  startDate: null,
  endDate: null,
  profit: {
    isLoading: 0,
    data: [],
  },
  sale: {
    isLoading: 0,
    data: [],
  },
  purchase: {
    isLoading: 0,
    data: [],
  },
}

// Action Creators
/// setShardedRange(startDate, endDate)
const setShardedRange = createAction(
  "SET_SHARDED_RANGE",
  (startDate, endDate) => ({ startDate, endDate }),
)
/// setShardedLoading(type, flag)
const setShardedLoading = createAction("SET_SHARDED_LOADING", (type, flag) => ({
  type,
  flag: flag ? 1 : -1,
}))
/// setShardedData(type, data)
const setShardedData = createAction("SET_SHARDED_DATA", (type, data) => ({
  type,
  data,
}))

const nullSharded = createAction("NULL_SHARDED")

// Reducer
const reducer = handleActions(
  {
    [setShardedRange]: (state, { payload: { startDate, endDate } }) => ({
      ...state,
      startDate,
      endDate,
    }),
    [setShardedLoading]: (state, { payload: { type, flag } }) =>
      mergeDeepRight(state, {
        [type]: { isLoading: state[type].isLoading + flag },
      }),
    [setShardedData]: (state, { payload: { type, data } }) =>
      mergeDeepRight(state, { [type]: { data } }),
    [nullSharded]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
  defaultState,
)
export default reducer

// Thunk
export function refreshShardedAnalytics(type) {
  return (dispatch, getState) => {
    const {
      profile,
      shardedAnalytics: { startDate, endDate },
    } = getState()
    const storeId = profile.currentStore.id
    dispatch(setShardedLoading(type, true))
    return apiGet(shardedAnalyticsApi, {
      storeId,
      from: startOfDay(startDate).toISOString(),
      to: endOfDay(endDate).toISOString(),
      type: type,
    })
      .onOk((res) => {
        dispatch(setShardedData(type, res.data.response))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        dispatch(setShardedLoading(type, false))
      })
      .startSingle(type)
  }
}

export function changeShardedAnalyticsRange(startDate, endDate) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(setShardedRange(startDate, endDate))
    forEachObjIndexed(
      (type) => dispatch(refreshShardedAnalytics(type)),
      shardedAnalyticsTypes,
    )
  }
}

export function refreshAllShardedAnalytics() {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    forEachObjIndexed(
      (type) => dispatch(refreshShardedAnalytics(type)),
      shardedAnalyticsTypes,
    )
  }
}

// FOR ONE PRODUCT

export function refreshShardedProductAnalytics(type, stockId) {
  return (dispatch, getState) => {
    const {
      profile,
      shardedAnalytics: { startDate, endDate },
    } = getState()
    const storeId = profile.currentStore.id
    dispatch(setShardedLoading(type, true))
    return apiGet(productShardedAnalyticsApi, {
      storeId,
      from: startOfDay(startDate).toISOString(),
      to: endOfDay(endDate).toISOString(),
      type: type,
      stockId,
    })
      .onOk((res) => {
        dispatch(setShardedData(type, res.data.response))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        dispatch(setShardedLoading(type, false))
      })
      .startSingle(type)
  }
}

export function changeShardedProductAnalyticsRange(
  startDate,
  endDate,
  stockId,
) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(setShardedRange(startDate, endDate))
    forEachObjIndexed(
      (type) => dispatch(refreshShardedProductAnalytics(type, stockId)),
      shardedAnalyticsTypes,
    )
  }
}

export function refreshAllShardedProductAnalytics(stockId) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    forEachObjIndexed(
      (type) => dispatch(refreshShardedProductAnalytics(type, stockId)),
      shardedAnalyticsTypes,
    )
  }
}

export function nullShardedProductAnalytics(startDate, endDate) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(nullSharded(defaultState))
    dispatch(setShardedRange(startDate, endDate))
    // type.map((t) => {
    //   dispatch(setShardedData(t, res.data.response))
    // })
  }
}
